import { Controller } from '@hotwired/stimulus'

// Shared Button controller (minimal placeholder)
// Attach to buttons/links via `data-controller="button"` when we need shared behavior
// Currently a no-op but acts as a hook for future analytics/effects.
export default class extends Controller {
  connect() {
    // Intentionally minimal: provides a single place to add cross-app button behavior
    // e.g. analytics, focus styling, or ripple effects in future.
  }

  // Optional smooth scroll helper. If an element (link or button) has an href with a hash
  // or a `data-scroll-target` attribute, calling this method will smoothly scroll the
  // referenced element into view and prevent the default link jump.
  maybeScroll(event: Event) {
    try {
      const el = (event.currentTarget || event.target) as HTMLElement
      // If this is a link with an href containing a hash, use that as target
      let targetSelector: string | null = null
      if ((el as HTMLAnchorElement).href) {
        try {
          const href = (el as HTMLAnchorElement).getAttribute('href')
          if (href && href.startsWith('#')) targetSelector = href
        } catch (e) {
          // ignore
        }
      }

      // data-scroll-target (kebab-case attribute) support
      if (!targetSelector) {
        // access dataset: scrollTarget corresponds to data-scroll-target
        // @ts-ignore
        targetSelector = (el.dataset && (el.dataset.scrollTarget || el.dataset.scrollTo)) || null
      }

      if (targetSelector) {
        const target = document.querySelector(targetSelector)
        if (target) {
          event.preventDefault()
          // smooth scroll
          ;(target as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }
    } catch (err) {
      // swallow — do not break clicking behavior
    }
  }
}
